import React from "react";
import { Edit, SimpleForm, TextInput, SelectInput } from "react-admin";
import OrgSelector from "../../components/OrgSelector";
import { filteredAlerts } from "../../defaults/ZoneAlerts";

const PendantEdit = (props) => {
  return (
    <Edit {...props} title="Edit Pendant">
      <SimpleForm {...props}>
        <TextInput source="name" label="Pendant Name" required />
        <SelectInput
          source="type"
          label="Pendant Type"
          choices={filteredAlerts()}
          required
        />
        <TextInput source="uid" label="Unique Identifier" required />
        <OrgSelector source="org_id" label="Organization" required />
      </SimpleForm>
    </Edit>
  );
};

export default PendantEdit;
